import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import styled from "styled-components";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import RelatorioMsl from "./Components/Relatorio";
import { useSelections } from "../../context/Selections";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "95%",
  justifyContent: "flex-start",
  width: "100%",
});

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
`;

function MslDesktop({ app, config }) {
  const [selectedValue, setSelectedValue] = useState("Todos");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const [detail, setDetail] = useState("");
  const [detailMessage, setDetailMessage] = useState(0);

  const handleChange = (event) => {
    app.field("Tipo_Apuracao").selectMatch(event.target.value, true);
    setSelectedValue(event.target.value);
    console.log(event.target.value);
  };

  async function detailSelecao() {
    await app.variable.getContent("vSelecao_Mix", (reply) => {
      const data = reply.qContent.qString;
      setDetail(data.substring(0, 15));
    });
  }

  useEffect(() => {
    detailSelecao();
    setDetailMessage(0);
    selections.map((s) => {
      if (s.qField === "Grupo Distribuição") {
        setDetailMessage(1);
      }
    });
  }, [selections]);

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Tipo_Apuracao")
        : null;
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  return (
    <div className="app msl">
      <div className="appContent">
        <FormControl className="container-form-control">
          <RadioGroup
            defaultValue="Todos"
            row
            name="row-radio-buttons-group"
            className="radio-group radio-group-button-export"
            value={selectedValue}
            onChange={handleChange}
            sx={{ marginLeft: "20px" }}
          >
            <FormControlLabel
              value="Todos"
              control={
                <Radio
                  size="small"
                  defaultChecked
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Todos"
            />

            <FormControlLabel
              value="Gestão de Vendas"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Gestão de Vendas"
            />

            <FormControlLabel
              value="Gestão de Positivação"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Gestão de Positivação"
            />

            <FormControlLabel
              value="Gestão Clientes DQB"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Gestão Clientes DQB"
            />

            <FormControlLabel
              value="Gestão da Informação"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Gestão da Informação"
            />

            <FormControlLabel
              value="Gestão de Planejamento"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Gestão de Planejamento"
            />

            <FormControlLabel
              value="Gestão de Execução"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Gestão de Execução"
            />

            <FormControlLabel
              value="Gestão de Pessoas"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Gestão de Pessoas"
            />

            <FormControlLabel
              value="Faseamento"
              control={
                <Radio
                  size="small"
                  sx={{
                    color: "#0DA9D5",
                    "&.Mui-checked": {
                      color: "#0DA9D5",
                    },
                  }}
                />
              }
              label="Faseamento"
            />
          </RadioGroup>
        </FormControl>

        <LayoutCardsWrapper>
          <p className="container-titles">
            <span>Período Fechamento :</span>

            <NativeObject
              app={app}
              key="SbbnKHE"
              reference={{ id: "SbbnKHE" }}
              className="container-object"
              style={{ width: "70px" }}
            />
          </p>
          <LayoutCardWrapper>
            <div className="group-cards">
              {selectedValue === "Todos" ? (
                <>
                  {detail === "1" && (
                    <div className="adm-cards">
                      <Card
                        app={app}
                        header={{
                          hardTitle: "Parcial",
                        }}
                        style={{
                          width: "15%",
                          height: "150%",
                          padding: "14px",
                        }}
                      >
                        <NativeObject
                          app={app}
                          key="fJTpm"
                          reference={{ id: "fJTpm" }}
                          style={{
                            width: "100%",
                            height: "100%",
                          }}
                        />
                      </Card>

                      <Card
                        app={app}
                        header={{
                          hardTitle: "Plus",
                        }}
                        style={{
                          width: "15%",
                          height: "150%",
                          padding: "14px",
                        }}
                      >
                        <NativeObject
                          app={app}
                          key="LYJzMq"
                          reference={{ id: "LYJzMq" }}
                          style={{
                            width: "100%",
                            height: "100%",
                          }}
                        />
                      </Card>
                    </div>
                  )}

                  <Grid container justifyContent={"flex-end"}>
                    <Card
                      app={app}
                      exportContainer
                      exportTable
                      exportTablesId
                      exportTableId={[
                        "ZhLTHQH",
                        "wmmnp",
                        "hryUcH",
                        "GpZGB",
                        "QVwYBCG",
                        "hsPgYGA",
                        "wefZHA",
                        "BceLA",
                        "BLRSjr",
                        "AhYd",
                        "PyESRR",
                        "nHsBp",
                      ]}
                      className="card-export"
                    ></Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Gestão de Vendas",
                      }}
                      style={{
                        width: "100%",
                        height: "80%",
                        marginBottom: "20px",
                      }}
                    >
                      <NativeObject
                        app={app}
                        key="ZhLTHQH"
                        reference={{ id: "ZhLTHQH" }}
                        style={{
                          width: "100%",
                          height: "100%",
                          marginBottom: "20px",
                        }}
                      />
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Gestão de Positivação",
                      }}
                      style={{
                        width: "100%",
                        height: "80%",
                        marginBottom: "20px",
                      }}
                    >
                      <NativeObject
                        app={app}
                        key="wmmnp"
                        reference={{ id: "wmmnp" }}
                        style={{
                          width: "100%",
                          height: "100%",
                          marginBottom: "20px",
                        }}
                      />
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Gestão Clientes DQB",
                      }}
                      style={{
                        width: "100%",
                        height: "160%",
                        marginBottom: "20px",
                      }}
                    >
                      <NativeObject
                        app={app}
                        key="hryUcH"
                        reference={{ id: "hryUcH" }}
                        style={{
                          width: "100%",
                          height: "70%",
                        }}
                      />
                      <NativeObject
                        app={app}
                        key="GpZGB"
                        reference={{ id: "GpZGB" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Gestão da Informação",
                      }}
                      style={{
                        width: "100%",
                        height: "65%",
                        marginBottom: "20px",
                      }}
                    >
                      <NativeObject
                        app={app}
                        key="QVwYBCG"
                        reference={{ id: "QVwYBCG" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Gestão de Planejamento",
                      }}
                      style={{
                        width: "100%",
                        height: "180%",
                        marginBottom: "20px",
                      }}
                    >
                      <NativeObject
                        app={app}
                        key="hsPgYGA"
                        reference={{ id: "hsPgYGA" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                      <NativeObject
                        app={app}
                        key="wefZHA"
                        reference={{ id: "wefZHA" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                      <NativeObject
                        app={app}
                        key="BceLA"
                        reference={{ id: "BceLA" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Gestão de Execução",
                      }}
                      style={{
                        width: "100%",
                        height: "65%",
                        marginBottom: "20px",
                      }}
                    >
                      <NativeObject
                        app={app}
                        key="BLRSjr"
                        reference={{ id: "BLRSjr" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Gestão de Pessoas",
                      }}
                      style={{
                        width: "100%",
                        height: "120%",
                        marginBottom: "20px",
                      }}
                    >
                      <NativeObject
                        app={app}
                        key="AhYd"
                        reference={{ id: "AhYd" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                      <NativeObject
                        app={app}
                        key="PyESRR"
                        reference={{ id: "PyESRR" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Faseamento",
                      }}
                      style={{
                        width: "100%",
                        height: "65%",
                        marginBottom: "20px",
                      }}
                    >
                      <NativeObject
                        app={app}
                        key="nHsBp"
                        reference={{ id: "nHsBp" }}
                        style={{
                          width: "100%",
                          height: "100%",
                        }}
                      />
                    </Card>
                  </Grid>
                </>
              ) : null}

              {selectedValue === "Gestão de Vendas" ? (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Gestão de Vendas",
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="ZhLTHQH"
                >
                  <NativeObject
                    app={app}
                    key="ZhLTHQH"
                    reference={{ id: "ZhLTHQH" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ) : null}

              {selectedValue === "Gestão de Positivação" ? (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Gestão de Positivação",
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="wmmnp"
                >
                  <NativeObject
                    app={app}
                    key="wmmnp"
                    reference={{ id: "wmmnp" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ) : null}

              {selectedValue === "Gestão Clientes DQB" ? (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Gestão Clientes DQB",
                  }}
                  style={{
                    width: "100%",
                    height: "200%",
                  }}
                  exportContainer
                  exportTable
                  exportTablesId
                  exportTableId={["hryUcH", "GpZGB"]}
                >
                  <NativeObject
                    app={app}
                    key="hryUcH"
                    reference={{ id: "hryUcH" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                  <NativeObject
                    app={app}
                    key="GpZGB"
                    reference={{ id: "GpZGB" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ) : null}

              {selectedValue === "Gestão da Informação" ? (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Gestão da Informação",
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="QVwYBCG"
                >
                  <NativeObject
                    app={app}
                    key="QVwYBCG"
                    reference={{ id: "QVwYBCG" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ) : null}

              {selectedValue === "Gestão de Planejamento" ? (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Gestão de Planejamento",
                  }}
                  style={{
                    width: "100%",
                    height: "300%",
                  }}
                  exportContainer
                  exportTable
                  exportTablesId
                  exportTableId={["hsPgYGA", "wefZHA", "BceLA"]}
                >
                  <NativeObject
                    app={app}
                    key="hsPgYGA"
                    reference={{ id: "hsPgYGA" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                  <NativeObject
                    app={app}
                    key="wefZHA"
                    reference={{ id: "wefZHA" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                  <NativeObject
                    app={app}
                    key="BceLA"
                    reference={{ id: "BceLA" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ) : null}

              {selectedValue === "Gestão de Execução" ? (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Gestão de Execução",
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="BLRSjr"
                >
                  <NativeObject
                    app={app}
                    key="BLRSjr"
                    reference={{ id: "BLRSjr" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ) : null}

              {selectedValue === "Gestão de Pessoas" ? (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Gestão de Pessoas",
                  }}
                  style={{
                    width: "100%",
                    height: "200%",
                  }}
                  exportContainer
                  exportTable
                  exportTablesId
                  exportTableId={["AhYd", "PyESRR"]}
                >
                  <NativeObject
                    app={app}
                    key="AhYd"
                    reference={{ id: "AhYd" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                  <NativeObject
                    app={app}
                    key="PyESRR"
                    reference={{ id: "PyESRR" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ) : null}

              {selectedValue === "Faseamento" ? (
                <Card
                  app={app}
                  header={{
                    hardTitle: "Faseamento",
                  }}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                  exportContainer
                  exportTable
                  exportTableId="nHsBp"
                >
                  <NativeObject
                    app={app}
                    key="nHsBp"
                    reference={{ id: "nHsBp" }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                  />
                </Card>
              ) : null}
            </div>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

MslDesktop.defaultProps = {
  app: null,
  config: {},
};

MslDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default MslDesktop;
